"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTINE_MARK_EXTRA_DAYS = exports.ROUTINE_MARK_TOTAL_DAYS = exports.ROUTINE_MARK_CURRENT_DAY = exports.ROUTINE_MARK_NEXT_DAYS = exports.ROUTINE_MARK_PREVIOUS_DAYS = exports.ROUTINE_MARK_DATE_FORMAT = void 0;
exports.ROUTINE_MARK_DATE_FORMAT = 'YYYY-MM-DD';
// Number of days to fetch for previous / next
exports.ROUTINE_MARK_PREVIOUS_DAYS = 6;
exports.ROUTINE_MARK_NEXT_DAYS = 6;
exports.ROUTINE_MARK_CURRENT_DAY = 1;
// Total 13 days (6 previous + 1 current + 6 next)
exports.ROUTINE_MARK_TOTAL_DAYS = exports.ROUTINE_MARK_PREVIOUS_DAYS + exports.ROUTINE_MARK_CURRENT_DAY + exports.ROUTINE_MARK_NEXT_DAYS;
// Extra days to fetch for timezone compensation
exports.ROUTINE_MARK_EXTRA_DAYS = 2;
//# sourceMappingURL=routine.js.map